/**
 * Import Lib & assets
 */

import React, { useContext } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

/**
 * Import Context
 */

import { AppContext } from "context/appContext";
import { ContentContext } from "context/contentContext";

/**
 * import components
 */

import { Item__product } from "components/item/item";
import { Shadow__container } from "components/shadow/shadow";

/**
 * styled components
 */

const Shadow = styled(Shadow__container)`
  padding-top: 34px;

  ${t.mixins.sm(`
    padding-top: 0;
    border-bottom: 1px solid ${t.color.greyMercury};
  `)}
`;

const Container = styled.div`
  padding-top: 19px;
  ${t.mixins.flex({ wrap: "wrap", justify: "flex-start" })}

  ${t.mixins.sm(`
    ${t.mixins.flex({ wrap: "wrap", justify: "center" })}
  `)}
`;
/**
 * products component is..
 */

const List__products = ({ products }) => {
  const { updateChoices, getChoices, choiceError } = useContext(AppContext);
  const { c } = useContext(ContentContext);
  const choices = getChoices();
  return (
    <Shadow title={c("home.products.title")}>
      <Container>
        {products.map(product => {
          const selected = !!choices.find(choice => choice.id === product.id);
          const error = choiceError === product.id;
          return (
            <Item__product
              key={product.id}
              product={product}
              updateValue={updateChoices}
              selected={selected}
              error={error}
            />
          );
        })}
      </Container>
    </Shadow>
  );
};

export default List__products;

List__products.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
};

List__products.defaultProps = {
  style: {},
};

/*
    import List__products from 'components/list/products/list__products'
    <List__products />
  */
